import { apiSaveSettings, apiLoadSettings } from "./baseApi"

export const apiSaveHolidaySettings = (data, callback) => {
  apiSaveSettings(data, callback, 'holiday')
}

export const apiLoadHolidaySettings = (callback) => {
  apiLoadSettings(callback, 'holiday')
}